export default __webpack_public_path__ + "static/media/chat-bg.e9e345d3.png";